/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Paper,
  Typography,
  Grid,
  Chip,
} from "@material-ui/core";
import { punchesRef } from "../../services/firebase";
import { useLocation, useHistory } from "react-router-dom";
import { AccessTime as Watch, DateRange, Close } from "@material-ui/icons";
import { KeyboardTimePicker, KeyboardDatePicker } from "@material-ui/pickers";
import * as React from "react";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Draggable from "react-draggable";
import GroupTabs from "./GroupTabs";
import { getLocationForCountry } from "services/bulkUpload";
import {
  getProjectsByCountry,
  getPunchData,
  setLastPunch,
  getWorkerActivity
} from "services/index";
import { deleteIndividualPunch } from "services/index";
import {
  getProjectDetailsByCountry,
  getActivityGroups,
  getJobFamilies,
  getLocations,
  selectedWeekOnReview,
} from "redux/actions/appActions";

import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { getEndOfWeek } from "utils";
import { useDispatch, useSelector } from "react-redux";
import {
  addPunch,
  updatePunch,
  getNewWorkerPunchRecords,
  getWeekNumber,
} from "../../../src/services";
//import Confirmation from "../../../src/components/Confirmation";
import Confirmation from "./Confirmation";
import ConfirmDialog from "components/ConfirmDialog";
import {
  EXCEPTIONS,
  DEFAULT_EXCEPTION,
  SET_EMPTY,
  NO_EXCEPTION,
  MISSED_CLOCK_IN,
  MISSED_CLOCK_OUT,
  PROJECT,
  CLOCK_OUT,
  DEVICE_DETAILS,
} from "../../../src/config";
import I18n from "i18n";
import {
  isEmptyObject,
  getDistrictsByCountry,
  isDateValid,
  setDefaultValue,
  getProjectInfoEntryType,
} from "../../../src/utils/index";

import {
  ZERO,
  NEGATIVE,
  EQUAL,
  OVERLAPPING,
  POSITIVE,
  ADD,
  UPDATE,
  categoryPunch,
} from "pages/Punch/constants";

import {
  dateConfig,
  timeConfig,
  EDIT_STATUS,
  NEW_STATUS,
  DELETED_STATUS
} from "../../../src/config/index";

import FormControl from "@material-ui/core/FormControl";
// import { getActivityGroups, getJobFamilies } from "redux/actions/appActions";
import i18n from "i18next";
import moment from "moment";
import {
  deepEqual,
  getTotals,
  createorUpdateTimeSheetfromPunch,
} from "./utils";
import {
  getEarliestSelectableTimesheetWeekStart,
  isTimesheetEditRestrictedByRole,
  resolveTimesheetAuthDate,
} from "./historicalTimesheetAuth";
import {
  getActivityGroupByLanguage,
  getErrors,
  getJobFamiliesByLanguage,
  getExceptionsByLanguage,
  getUniqueID,
  getCustomerSite,
  getBuildings,
  getPunch,
  getProjectsByActivityGroup,
  getActivityDetails,
} from "../../../src/utils/punch";
import SplitDialog from "./SplitDialog";
import { properCase } from "utils";
import { Link } from "react-router-dom";
const filterDetailsByActivityGroup = (
  projectDetailsByCountry,
  group,
  jobfamily,
  selectedDistrict
) => {
  if (projectDetailsByCountry == null) return [];
  const detailsByProject = [];
  projectDetailsByCountry.filter((projectDetail, index, projectDetails) => {
    if (projectDetail.activityGroup === group?.value) {
      detailsByProject.push(projectDetail);
    }
  });

  const detailByJobRoleRestricted = [];

  detailsByProject.map((detail, index) => {
    if (detail.isJobRoleRestricted !== undefined) {
      if (
        detail.isJobRoleRestricted === true &&
        detail.jobRoles.includes(jobfamily)
      ) {
        detailByJobRoleRestricted.push(detail);
      } else if (detail.isJobRoleRestricted === false) {
        detailByJobRoleRestricted.push(detail);
      }
    } else {
      detailByJobRoleRestricted.push(detail);
    }
  });

  let detailsByDistrictRestricted = [...detailByJobRoleRestricted];
    if(group?.value){
      detailsByDistrictRestricted = [];
      detailByJobRoleRestricted.forEach((details)=>{
      if(details.isDistrictRestricted && selectedDistrict){
        if(details.restrictedDistricts && details.restrictedDistricts.includes(selectedDistrict)){
          detailsByDistrictRestricted.unshift({
            ...details,
            parent: I18n.t("other.lblDistricts"),
          })
        }
      }
      else{
        detailsByDistrictRestricted.push({
          ...details,
          parent: I18n.t("other.lblAll"),
        })
      }
    })
  }
  detailsByDistrictRestricted = detailsByDistrictRestricted.sort((a,b)=>{
    if(a.parent == b.parent){
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    }
    else{
      return a.parent-b.parent
    }
  });
  return detailsByDistrictRestricted;
};

const tabs = [
  { id: "transactional", label: "Transactional" },
  { id: "non-transactional", label: "Non Transactional" },
  { id: "project", label: "Project" },
  { id: "meal", label: "Meal" },
  { id: "leave", label: "Leave" },
  { id: "building-moves", label: "Building Moves" },
];

function PaperComponent(props) {
  return (
    <Draggable
      handle="#drag-handle"
      cancel={'[class*="MuiDialogContent-root"]'}
      bounds={"parent"}
    >
      <Paper
        style={{
          border: "1px solid white",
          borderRadius: "8px",
        }}
        {...props}
      />
    </Draggable>
  );
}

export default function AddDialog(props) {
  const {
    flagForEventDropOrDrag,
    inProgressPunchFlag,
    dataForSplitAndSplitOpen,
    addOpen,
    onAddClose,
    onUpdateClose,
    activity,
    onCancel,
    onDelete,
    setLoading,
    loading,
    dropdowns,
    errors,
    disabled,
    setAddopen,
    type,
    selectedWeek,
    setNonew,
    setDeleted,
    setActivityGroupTotals,
  } = props;

  const theme = useTheme();

  console.log("props activity:", activity);

  let exceptionOptions = getExceptionsByLanguage(i18n.language, EXCEPTIONS);
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const location = useLocation();

  //console.log("this is last punch id ", lastPunchId)

  let currentPunch;
  const history = useHistory();

  const [confirmDialog, setConfirmDialog] = React.useState({
    isOpen: false,
    title: "pgPunch.tlConfirmation",
    subTitle: "pgReview.msgDeletePunch",
    isLoading: false,
  });

  const [confirmationBox, setConfirmationBox] = React.useState({
    isOpen: false,
    title: t("pgPunch.tlConfirmation"),
    subTitle: t("pgReview.msgDeleteSuccess"),
  });

  const selectedWorker = dropdowns?.selectedWorker;
  const [lastPunchId, setLastPunchId] = React.useState("")
  // setLastPunchId(selectedWorker && selectedWorker.lastPunchId);
  // if (selectedWorker) {
  //   setLastPunchId(selectedWorker.lastPunchId);
  // }
  //const lastPunchId = selectedWorker && selectedWorker?.lastPunchId;
  console.log("this is last punchid ", lastPunchId);

  const [confirmationMsg, setConfirmationMsg] = React.useState(false);
  const [createdPunchId, setcreatedPunchId] = React.useState("");
  const [confirmationMsgText, setConfirmationMsgText] =
    React.useState(SET_EMPTY);
  const [confirmationTitleText, setConfirmationTitleText] =
    React.useState("Confirmation");
  const [allowNavigation, setAllowNavigation] = React.useState(true);
  const [exception, setException] = React.useState(DEFAULT_EXCEPTION);
  const [customerSite, setCustomerSite] = React.useState(SET_EMPTY);
  const [errCustomerSite, setErrCustomerSite] = React.useState(false);
  const [customerSiteVisible, setCustomerSiteVisible] = React.useState(false);
  const [selectedIndexGroup, setSelectedIndexGroup] = React.useState(false);
  const [oldData, setOldData] = React.useState(null);
  const [newData, setNewData] = React.useState(null);
  const [errorData, setErrorData] = React.useState(false);
  const [deleteButtonEnabled, setDeleteButtonEnabled] = React.useState(false);
  const [lastpunchDetails, setLastPunchDetails] = React.useState({});
  const [selectStartErr, setSelectStartErr] = React.useState(false);
  const [selectEndErr, setSelectEndErr] = React.useState(false);
  const [flagForCustomerSiteVisible, setFlagForCustomerSiteVisible] =
    React.useState(false);
  const [projectDetails, setProjectDetails] = React.useState(SET_EMPTY);
  const [projectInfoEntryType, setProjectInfoEntryType] =
    React.useState(SET_EMPTY);

  React.useEffect(() => {
    dispatch(getActivityGroups());
    dispatch(getJobFamilies());
    setErrCustomerSite(false);
    //    setOldData({ records: initialRecord, weekTotal: initialTotalsObj });
  }, []);

  React.useEffect(()=>{
     if(selectedWorker && selectedWorker?.lastPunchId){
       getWorkerActivity(selectedWorker.workerId).then((doc)=>{
         const workerActivity = doc.data();
         setLastPunchId(workerActivity?.lastPunchId);
         console.log("selectedWorker..",workerActivity?.lastPunchId)
       }).catch((err)=>{
         console.log("error fetching lastPunchId", err);
       })
     }
  },[selectedWorker])

  const closeModalConfirmationMsg = () => {
    setConfirmationMsg(false);
    setIsSaveDisabled(false);

    if (
      (!activity?.updateFlag || activity?.updateFlag != true) &&
      errorData === false
    )
      handleClose(createdPunchId);
    else if (
      activity?.updateFlag &&
      activity?.updateFlag === true &&
      errorData === false &&
      !deleteButtonEnabled
    )
      updateEvent(createdPunchId);

    if (deleteButtonEnabled && deleteButtonEnabled === true) deleteModal();

    setDeleteButtonEnabled(false);
    if (errorData && errorData === true) {
      //console.log("errorData::New ",errorData);
      // setAddopen(false);
      // onCancel(true);
    }
  };

  React.useEffect(() => {
    if (lastPunchId) {
      getPunchData(lastPunchId)
        .then((doc) => {
          let data = doc.data();
          if (data.status && data.status === "deleted") {
            setLastPunchDetails({});
          } else {
            setLastPunchDetails(data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setLastPunchDetails({});
    }
  }, [lastPunchId, addOpen, selectedWorker]);

  //console.log("this is last punchDetails ", lastpunchDetails);

  React.useEffect(() => {
    if (selectedWorker) {
      getProjectsByCountry(selectedWorker.country)
        .then((data) => {
          if (data) {
            setLoading(false);
            dispatch(getProjectDetailsByCountry(data));
          }
        })
        .catch((err) => {
          console.error("No response from getProjectDetailsByCountry:: ", err);
        });
    }
  }, [selectedWorker, addOpen]);

  const appConfig = useSelector((state) => state.appConfig);
  const user = useSelector((state) => state.user);
  const loggedInSupervisor = user.auth.user.workerId;
   const { isLoading, userRole, error:userRoleError } = useSelector(
      (state) => state.user.imtRole
    );
  
  const { jobFamilies, activityGroups, projectDetailsByCountry } = appConfig;
  const [activityGroup, setActivityGroup] = React.useState([]);
  const [freeFormText, setFreeFormText] = React.useState("");
  const [jobFamiliyOption, setJobFamilyOption] = React.useState([]);
  const [activityGroupOption, setActivityGroupOption] = React.useState([]);
  const [projectOption, setProjectOptions] = React.useState([]);

  const [isSaveDisabled, setIsSaveDisabled] = React.useState(true);
  const [isCancelDisabled, setIsCancelDisabled] = React.useState(false);
  const [isokayDisabled, setIsokayDisabled] = React.useState(false);
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());

  const [selectStartDate, setSelectStartDate] = React.useState(new Date());
  const [selectEndDate, setSelectEndDate] = React.useState(new Date());

  const imtRoleName = userRole?.role;
  // Supervisor: last 3 weeks. Support/Admin: last 3 months (historical edits).
  const selectableWeekStartDate = React.useMemo(
    () => getEarliestSelectableTimesheetWeekStart(imtRoleName),
    [imtRoleName]
  );
  const selectedWeekStartDate = selectableWeekStartDate;
  // Prefer activity.start so auth is not blocked by selectStartDate defaulting
  // to today before the activity sync effect runs.
  const effectiveTimesheetDate = resolveTimesheetAuthDate({
    activityStart: activity?.start,
    selectStartDate,
    startDate,
    selectedWeek,
    fallbackDate: selectedWeekStartDate,
  });
  // Support: editable when activity OR selected week is older than 3 weeks
  // (week of Sep 20 unlocks even if activity is on Sep 24 within that week).
  // Managers: blocked when activity date is historical. Admin: not restricted here.
  const isTimesheetEditRestricted = isTimesheetEditRestrictedByRole(
    effectiveTimesheetDate,
    imtRoleName,
    new Date(),
    selectedWeek
  );

  const [jobfamily, setJobfamily] = React.useState("");
  const [project, setProject] = React.useState("");
  const [showFreeForm, setShowFreeForm] = React.useState(false);
  const [isDisabled, setDisabled] = React.useState(false);

  const [districts, setDistricts] = React.useState([]);

  const [buildings, setBuildings] = React.useState([]);
  const [selectedDistrict, setSelectedDistrict] = React.useState("");
  const [selectedBuilding, setSelectedBuilding] = React.useState("");
  const [lastPunchIndex, setLastPunchIndex] = React.useState(0);
  const [flagForChanges, setFlagForChanges] = React.useState(false);
  const [isDeleteDisabled, setIsDeleteDisabled] = React.useState(false);
  const [confirmationInTrip, setConfirmationInTrip] = React.useState(false);
  const customerSiteLabel = t("pgPunch.phCustomerSite") + "*";
  const deleteLabel = t("other.tblDel");
  const timesheetJobFamily = t("other.timeSheetJobFamily") + "*";

  const buildingLabel = properCase(t("pgPunch.lblBuilding")) + "*";
  const districtLabel = properCase(t("pgPunch.lblDistrict")) + "*";

  React.useEffect(() => {
    setStartDate(activity?.start);
    setEndDate(activity?.end);
    setSelectStartDate(activity?.start);
    setSelectEndDate(activity?.end);
    setSelectedDistrict(activity?.districtId);

    if (activity?.group) setActivityGroup(activity?.group);

    if (activity?.jobfamily) setJobfamily(activity?.jobfamily);
    else if (activity?.jobName) setJobfamily(activity?.jobName);
    else setJobfamily("");

    if (activity?.project) setProject(activity?.project);
    if (activity?.jobProjectInfo) setProject(activity?.jobProjectInfo);
    if (!activity?.project && !activity?.jobProjectInfo) setProject("");

    if (activity?.freeFormText) setFreeFormText(activity?.freeFormText);
    else if (activity?.jobProjectInfo)
      setFreeFormText(activity?.jobProjectInfo);
    else setFreeFormText("");

    console.log("this is activity group ", activity?.group);
    setOldData(activity);
    let buildings = [];
    let buildingsList = districts
      .filter((item) => item?.district === activity?.districtId)
      .map((item, index) => {
        buildings = item.buildings;
      });

    let activatedBuilding = Object.keys(buildings).filter(
      (e) => buildings[e].activityEnabled === true
    );
    selectedWorker?.isApprover
      ? setBuildings([...activatedBuilding, "Customer Site", "Remote"])
      : setBuildings([...activatedBuilding, "Customer Site"]);

    setSelectedBuilding(activity?.buildingId);
  }, [activity, districts]);

  React.useEffect(() => {
    //console.log("selectedBuilding:",selectedBuilding);
    if (!selectedBuilding) {
      setSelectedBuilding(SET_EMPTY);
      setCustomerSiteVisible(false);
    } else if (selectedBuilding && selectedBuilding === "Customer Site") {
      setCustomerSiteVisible(true);
      setCustomerSite(activity?.customerSite);
    } else {
      //console.log("building changed from customer site");
      setCustomerSiteVisible(false);
      setCustomerSite(SET_EMPTY);
    }
    if (addOpen) {
      setErrCustomerSite(false);
    }
  }, [selectedBuilding, addOpen]);

  React.useEffect(() => {

    const projInfoEntryType = getProjectInfoEntryType(
      jobfamily,
      jobFamiliyOption
    );
    setProjectInfoEntryType(projInfoEntryType);

    if (projInfoEntryType === "id" && activity && activity.projectDetails) {
      setProjectDetails(activity?.projectDetails);
    } else {
      setProjectDetails(SET_EMPTY);
    }
  }, [jobfamily, addOpen]);

  React.useEffect(() => {
    if (exception == "") {
      setException(DEFAULT_EXCEPTION);
    }
  }, [exception]);

  React.useEffect(() => {
    if (
      lastpunchDetails &&
      (!activity?.updateFlag || activity?.updateFlag !== true) &&
      lastpunchDetails.workerId &&
      lastpunchDetails.workerId == selectedWorker.workerId
    ) {
      setSelectedDistrict(lastpunchDetails?.districtId);
      setSelectedBuilding(lastpunchDetails?.buildingId);
      setJobfamily(lastpunchDetails?.jobName);
      setProject(lastpunchDetails?.jobProjectInfo);
      setFreeFormText(lastpunchDetails?.jobProjectInfo);
      setCustomerSite(lastpunchDetails?.customerSite);
      setProjectDetails(lastpunchDetails?.projectDetails);
      if (lastpunchDetails?.activityGroup) {
        setActivityGroup({
          id: lastpunchDetails?.activityGroup?.toLowerCase(),
          value: lastpunchDetails?.activityGroup,
        });
      }
      for (let eachKey in activityGroupOption) {
        ////console.log("eachKey:",Math.floor(eachKey));
        console.log(
          "this is set z key ",
          eachKey,
          activityGroupOption[eachKey].value?.toLowerCase()
        );
        if (
          activityGroupOption[eachKey].value?.toLowerCase() ===
          lastpunchDetails?.activityGroup?.toLowerCase()
        ) {
          //////console.log("eachKey:1",Math.floor(eachKey));
          setLastPunchIndex(Math.floor(eachKey));
          console.log(
            "this is set z activitygroup ",
            lastpunchDetails,
            lastPunchIndex,
            Math.floor(eachKey)
          );
        }
      }
      let buildings = [];
      let buildingsList = districts
        .filter((item) => item?.district === lastpunchDetails?.districtId)
        .map((item, index) => {
          buildings = item.buildings;
        });
      let activatedBuilding = Object.keys(buildings).filter(
        (e) => buildings[e].activityEnabled === true
      );
      selectedWorker?.isApprover
        ? setBuildings([...activatedBuilding, "Customer Site", "Remote"])
        : setBuildings([...activatedBuilding, "Customer Site"]);
    } else if (!activity?.updateFlag || activity?.updateFlag !== true) {
      setJobfamily("");
      setFreeFormText("");
      setProject("");
    }
  }, [lastpunchDetails, selectedWorker, addOpen]);

  // React.useEffect(() => {

  //   if(customerSite ===SET_EMPTY ){setCustomerSiteVisible(false);}

  // }, [customerSite]);

  React.useEffect(() => {
    selectStartDate &&
      isDateValid(selectStartDate) &&
      new Date(selectStartDate) >= new Date(selectableWeekStartDate) &&
      new Date(selectStartDate) <=
      new Date(moment(new Date()).add(1, "years").endOf("week"))
      ? setSelectStartErr(false)
      : setSelectStartErr(true);

    selectEndDate &&
      isDateValid(selectEndDate) &&
      new Date(selectEndDate) >= new Date(selectableWeekStartDate) &&
      new Date(selectEndDate) <=
      new Date(moment(new Date()).add(1, "years").endOf("week"))
      ? setSelectEndErr(false)
      : setSelectEndErr(true);
  }, [selectStartDate, selectEndDate, selectableWeekStartDate]);

  React.useEffect(() => {
    let show = false;

    //console.log("customerSiteVisible:",customerSiteVisible);
    let disableActivityGroups = ["leave"];
    if (
      selectedWorker &&
      startDate &&
      isDateValid(startDate) &&
      activityGroup &&
      selectedDistrict &&
      selectedBuilding &&
      endDate &&
      isDateValid(endDate) &&
      selectEndDate &&
      isDateValid(selectEndDate) &&
      new Date(selectEndDate) >= new Date(selectableWeekStartDate) &&
      new Date(selectEndDate) <=
      //new Date(moment(selectedWeekStartDate).endOf("week")) &&
      new Date(moment(new Date()).add(1, "years").endOf("week")) &&
      selectStartDate &&
      isDateValid(selectStartDate) &&
      new Date(selectStartDate) >= new Date(selectableWeekStartDate) &&
      new Date(selectStartDate) <=
      //new Date(moment(selectedWeekStartDate).endOf("week")) &&
      new Date(moment(new Date()).add(1, "years").endOf("week")) &&
      // ((disableActivityGroups.includes(
      //   activityGroup.value?.toLowerCase().trim()
      // ) &&
      //   !jobfamily) ||
      //   jobfamily)
      jobfamily
    )
      show = true;

    if (
      customerSiteVisible &&
      customerSiteVisible === true &&
      (!customerSite || customerSite === SET_EMPTY)
    )
      show = false;

    if (activityGroup?.value === 'Project') {
      if (showFreeForm && !freeFormText) {
        show = false;
      } else if (!showFreeForm && !project) {
        show = false;
      }
    }
    if (show === false) setIsSaveDisabled(true);
    else setIsSaveDisabled(false);
    const inTS = getDateAndTime(new Date(selectStartDate), new Date(startDate));
    const outTS = getDateAndTime(new Date(selectEndDate), new Date(endDate));
    setNewData({
      start: inTS,
      end: outTS,
      // selectStartDate: selectStartDate,
      // endDate: selectEndDate,
      title: activity?.title,
      updateFlag: true,
      id: activity?.id,
      buildingId: selectedBuilding,
      districtId: selectedDistrict,
      jobfamily: jobfamily,
      project: project,
      freeFormText: freeFormText,
      group: activity?.activityGroup,
    });
  }, [
    selectedWorker,
    startDate,
    activityGroup,
    selectedDistrict,
    selectedBuilding,
    jobfamily,
    endDate,
    project,
    freeFormText,
    customerSite,
    customerSiteVisible,
    selectStartDate,
    selectEndDate,
    showFreeForm,
    selectableWeekStartDate,
  ]);

  // React.useEffect(() => {

  //   //console.log("customerSiteVisible flag:",customerSiteVisible);
  //   if(customerSiteVisible && customerSiteVisible===true  && !customerSite) {
  //     setIsSaveDisabled(true);
  //   }else {

  //   }

  // },[customerSiteVisible]);

  // React.useEffect(() => {
  //   //console.log("oldData:",oldData);
  //   //console.log("newData:",newData);
  //   if (oldData && newData && activity?.updateFlag) {
  //     let valid = deepEqual(oldData, newData);
  //     ////console.log("deepEquals:", valid);
  //     if (valid && valid === true) setIsSaveDisabled(true);
  //     else setIsSaveDisabled(false);
  //   }
  // }, [oldData, newData]);

  const deleteDone = () => {
    setConfirmationBox({ ...confirmationBox, isOpen: false });
  };

  React.useEffect(() => {
    let show = showFreeForm;
    if (activityGroup) {
      if (projectOption.length == 0) {
        show = true;
      } else {
        show = false;
      }
    } else {
      show = false;
    }
    setShowFreeForm(show);
  }, [activityGroup, projectOption]);

  React.useEffect(() => {
    let jobFamilyOptions =
      jobFamilies !== null
        ? getJobFamiliesByLanguage(i18n.language, jobFamilies)
        : [];
    jobFamilyOptions =
      selectedWorker && selectedWorker.isApprover
        ? jobFamilyOptions
        : jobFamilyOptions.filter((item) => !item.mgrOnly);
    ////console.log("new activityGroup:",activityGroup);
    ////console.log("projectDetailsByCountry:",activityGroupsOptions);
    const activityGroupsOptions =
      activityGroups !== null
        ? getActivityGroupByLanguage(i18n.language, activityGroups)
        : [];
    const detailsByProject = filterDetailsByActivityGroup(
      projectDetailsByCountry,
      activityGroup,
      jobfamily,
      selectedDistrict
    );
    let projectOptions = detailsByProject.filter((e) => e.isActive);
    let filteredActivityGroups = jobFamilyOptions.filter((item) => {
      return item.actGrpsRestrctd === true &&
        item.actGrps.length > 0 && item.value === jobfamily;
    });
    let filtActivityGroupsOptions = [...activityGroupsOptions.map(group=>{return {...group,disabled:false}})];
    if (filteredActivityGroups && filteredActivityGroups.length > 0) {
      const restrictedActGrps = filteredActivityGroups[0].actGrps;
      filtActivityGroupsOptions = filtActivityGroupsOptions.map(
        (item) =>{ 
          let returnItem ={...item};
          if(restrictedActGrps.includes(item.value) || item.value === "Leave" || item.value === "Meal"){
            returnItem={...item,disabled:false}
          }else{
            returnItem={...item,disabled:true}
          }
          return returnItem
        }
      );
    }
    setActivityGroupOption([...filtActivityGroupsOptions])
    setJobFamilyOption(jobFamilyOptions);
    setProjectOptions([...projectOptions]);
  }, [
    jobFamilies,
    activityGroups,
    projectDetailsByCountry,
    activityGroup,
    i18n,
    jobfamily,
    selectedDistrict
  ]);

  React.useEffect(() => {
    if (
      moment(activity?.start).format("hhmm") !=
      moment(startDate).format("hhmm") ||
      moment(activity?.end).format("hhmm") != moment(endDate).format("hhmm") ||
      moment(activity?.start).format("DDMMYYYY") !=
      moment(selectStartDate).format("DDMMYYYY") ||
      moment(activity?.end).format("DDMMYYYY") !=
      moment(selectEndDate).format("DDMMYYYY") ||
      activity?.group?.value?.toLowerCase() !=
      activityGroup?.value?.toLowerCase() ||
      activity?.districtId != selectedDistrict ||
      activity?.buildingId != selectedBuilding ||
      activity?.customerSite != customerSite ||
      activity?.projectDetails != projectDetails ||
      (activity?.jobfamily != jobfamily && activity?.jobName != jobfamily) ||
      (activity?.project != project &&
        activity?.jobProjectInfo != project &&
        !showFreeForm) ||
      (activity?.freeFormText != freeFormText &&
        activity?.jobProjectInfo != freeFormText &&
        showFreeForm) ||
      (activity?.exceptionName?.toLowerCase() != exception?.toLowerCase() &&
        !(activity?.exceptionName == "" && exception == DEFAULT_EXCEPTION))
    ) {
      setFlagForChanges(true);
      setIsDeleteDisabled(true);
    } else {
      setFlagForChanges(false);
      setIsDeleteDisabled(false);
    }
  }, [
    activity,
    startDate,
    endDate,
    selectStartDate,
    selectEndDate,
    activityGroup,
    selectedDistrict,
    selectedBuilding,
    customerSite,
    jobfamily,
    project,
    freeFormText,
    exception,
    projectDetails,
  ]);

  let isPersist = false;

  const saveActivity = (deleteFlag, callback) => {
    // Align with UI: Support read-only on recent; managers blocked on historical.
    if (
      isTimesheetEditRestrictedByRole(
        resolveTimesheetAuthDate({
          activityStart: activity?.start,
          selectStartDate,
          startDate,
          selectedWeek,
          fallbackDate: selectedWeekStartDate,
        }),
        userRole?.role,
        new Date(),
        selectedWeek
      )
    ) {
      if (callback && typeof callback == "function") callback(false);
      return false;
    }
    if (activity?.updateFlag 
      && activity?.updateFlag === true
      && activity?.activityName !== CLOCK_OUT 
      && activity?.inTrip === true 
      && activity?.outTS ==='')
      {
        setConfirmationInTrip(true);
        return false;
      }
      else{
        setLoading(true);
        console.log("save activity called", deleteFlag);
        if (deleteFlag === true) {
          console.log("deletion happened");
          setDeleted(true);
        }
        saveHandler(deleteFlag)
          .then((docRef) => {
            setNonew(false); //some activity is created/updated hence nonew becomes false
            setIsCancelDisabled(false);
            setIsokayDisabled(false);
            if (callback && typeof callback == "function") callback(true);
            setLoading(false);
            //console.log("save activity called 1",docRef);
          })
          .catch((error) => {
            //console.log("error message:New",error);
            setIsokayDisabled(false);
            setIsCancelDisabled(false);
            switch (error) {
              case NEGATIVE:
                setFlag(
                  true,
                  t("pgReview.dialogueMsgs.errMsgNegative"),
                  t("other.tlError"),
                  false
                );

                break;
              case ZERO:
                setFlag(
                  true,
                  t("pgReview.dialogueMsgs.errMsgZero"),
                  t("other.tlError"),
                  false
                );

                break;
              case EQUAL:
                setFlag(
                  true,
                  t("pgReview.dialogueMsgs.errMsgEqual"),
                  t("other.tlError"),
                  false
                );

                break;

              case OVERLAPPING:
                setFlag(
                  true,
                  t("pgReview.dialogueMsgs.errMsgOverlapping"),
                  t("other.tlError"),
                  false
                );

                break;

              case "HISTORICAL_UNAUTHORIZED":
                break;

              default:
                break;
            }
            if (callback && typeof callback == "function") callback(false);
            setLoading(false);
          });
        }
    };
  const getDateAndTime = (date, time) => {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      time.getHours(),
      time.getMinutes(),
      time.getSeconds(),
      time.getMilliseconds()
    );
  };
  const saveHandler = async (deleteFlag) => {
    // Align with UI: Support read-only on recent; managers blocked on historical.
    if (
      isTimesheetEditRestrictedByRole(
        resolveTimesheetAuthDate({
          activityStart: activity?.start,
          selectStartDate,
          startDate,
          selectedWeek,
          fallbackDate: selectedWeekStartDate,
        }),
        userRole?.role,
        new Date(),
        selectedWeek
      )
    ) {
      return Promise.reject("HISTORICAL_UNAUTHORIZED");
    }
    return new Promise((resolve, reject) => {
      setIsSaveDisabled(true);
      setIsCancelDisabled(true);
      const actionBy = loggedInSupervisor;
      let customerSiteVal = getCustomerSite(customerSite);
      if (!customerSiteVisible) {
        customerSiteVal = SET_EMPTY;
      }

      if (customerSiteVisible && customerSite == SET_EMPTY) {
        setErrCustomerSite(true);
        setIsSaveDisabled(false);
      }
      let startDateStr = new Date(startDate);
      let selectDateStr = new Date(selectStartDate);
      let endDateStr = new Date(selectEndDate);
      let endDateTime = new Date(endDate);
      const inTS = new Date(
        selectDateStr.getFullYear(),
        selectDateStr.getMonth(),
        selectDateStr.getDate(),
        startDateStr.getHours(),
        startDateStr.getMinutes(),
        startDateStr.getSeconds(),
        startDateStr.getMilliseconds()
      ).toISOString();

      const _inLocalTS = new Date(
        selectDateStr.getFullYear(),
        selectDateStr.getMonth(),
        selectDateStr.getDate(),
        startDateStr.getHours(),
        startDateStr.getMinutes(),
        startDateStr.getSeconds(),
        startDateStr.getMilliseconds()
      ).toString();

      const inLocalTS = moment(_inLocalTS).format(dateConfig.format4);

      const outTS = new Date(
        endDateStr.getFullYear(),
        endDateStr.getMonth(),
        endDateStr.getDate(),
        endDateTime.getHours(),
        endDateTime.getMinutes(),
        endDateTime.getSeconds(),
        endDateTime.getMilliseconds()
      ).toISOString();

      const _outLocalTS = new Date(
        endDateStr.getFullYear(),
        endDateStr.getMonth(),
        endDateStr.getDate(),
        endDateTime.getHours(),
        endDateTime.getMinutes(),
        endDateTime.getSeconds(),
        endDateTime.getMilliseconds()
      ).toString();

      const outLocalTS = moment(_outLocalTS).format(dateConfig.format4);
      const actionTS = new Date().toISOString();
      const version = getUniqueID();

      let activityName = CLOCK_OUT;
      let isException = false;
      let exceptionName = SET_EMPTY;
      if (exception === NO_EXCEPTION) {
        isException = false;
      } else if (
        exception == MISSED_CLOCK_IN ||
        exception === MISSED_CLOCK_OUT
      ) {
        isException = true;
        exceptionName = exception;
      }

      if (!activity?.updateFlag || activity?.updateFlag !== true) {
        const status = NEW_STATUS;
        const newPunch = getPunch(
          activityGroup.value,
          activityName,
          selectedBuilding,
          selectedDistrict,
          customerSiteVal,
          exceptionName,
          isException,
          jobfamily,
          showFreeForm ? freeFormText : project,
          status,
          version,
          selectedWorker.workerId,
          actionTS,
          inTS,
          inLocalTS,
          outTS,
          outLocalTS,
          actionBy,
          DEVICE_DETAILS,
          categoryPunch,
          projectDetails
        );
        let isPass = "";
        let action = "";
        const startdateStr = moment(newPunch.inLocalTS).format(
          dateConfig.format6
        );
        const endDateStr = moment(newPunch.outLocalTS).format(
          dateConfig.format6
        );
        const recentPunchIn = moment(newPunch.inLocalTS).format(
          dateConfig.format7
        );
        const recentPunchOut = moment(newPunch.outLocalTS).format(
          dateConfig.format7
        );
        const dayDiff = parseInt(
          moment
            .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
            .asMinutes()
        );
        ////console.log("DayDIff......." + dayDiff);
        getNewWorkerPunchRecords(
          newPunch.workerId,
          moment(startdateStr).subtract(1, "days").format(dateConfig.format4),
          moment(endDateStr).add(1, "days").format(dateConfig.format4)
        )
          .then((querySnapshot) => {
            ////console.log("querySnapshot....." + querySnapshot);
            if (querySnapshot != undefined && querySnapshot.length > 0) {
              querySnapshot.forEach((doc) => {
                if (doc.outLocalTS !== "") {
                  doc.inLocalTS = moment(doc.inLocalTS).format(
                    dateConfig.format7
                  );
                  doc.outLocalTS = moment(doc.outLocalTS).format(
                    dateConfig.format7
                  );
                  if (recentPunchOut == recentPunchIn) {
                    isPass = ZERO;
                  } else if (recentPunchOut < recentPunchIn) {
                    isPass = NEGATIVE;
                  }
                  // else if (dayDiff >= 1440) {
                  //   isPass = DAY24HRS;
                  // }
                  else if (
                    recentPunchIn == doc.inLocalTS &&
                    recentPunchOut == doc.outLocalTS
                  ) {
                    isPass = EQUAL;
                  } else if (
                    (doc.inLocalTS > recentPunchIn &&
                      doc.inLocalTS < recentPunchOut) ||
                    (doc.outLocalTS > recentPunchIn &&
                      doc.outLocalTS < recentPunchOut) ||
                    (recentPunchIn > doc.inLocalTS &&
                      recentPunchIn < doc.outLocalTS) ||
                    (recentPunchOut > doc.inLocalTS &&
                      recentPunchOut < doc.outLocalTS)
                  ) {
                    isPass = OVERLAPPING;
                  } else {
                    if (
                      isPass != NEGATIVE &&
                      isPass != ZERO &&
                      // isPass != DAY24HRS &&
                      isPass != OVERLAPPING &&
                      isPass != EQUAL
                    ) {
                      isPass = POSITIVE;
                      action = ADD;
                    }
                  }
                } else {
                  doc.inLocalTS = moment(doc.inLocalTS).format(
                    dateConfig.format7
                  );
                  if (recentPunchOut == recentPunchIn) {
                    isPass = ZERO;
                  } else if (recentPunchOut < recentPunchIn) {
                    isPass = NEGATIVE;
                  }
                  if (
                    recentPunchIn < doc.inLocalTS &&
                    recentPunchOut > doc.inLocalTS
                  ) {
                    isPass = OVERLAPPING;
                  } else if (recentPunchIn == doc.inLocalTS) {
                    isPass = EQUAL;
                  } else {
                    if (
                      isPass != OVERLAPPING &&
                      isPass != EQUAL &&
                      isPass !== NEGATIVE &&
                      isPass !== ZERO
                    ) {
                      isPass = POSITIVE;
                      action = ADD;
                    }
                  }
                }
              });
            } else {
              if (recentPunchOut == recentPunchIn) {
                isPass = ZERO;
              } else if (recentPunchOut < recentPunchIn) {
                isPass = NEGATIVE;
              }
              // else if (dayDiff >= 1440) {
              //   isPass = DAY24HRS;
              // }
              else {
                if (
                  isPass != ZERO &&
                  // isPass != DAY24HRS &&
                  isPass != NEGATIVE
                ) {
                  isPass = POSITIVE;
                  action = ADD;
                }
              }
            }

            if (project && !showFreeForm) {
              newPunch.jobProjectInfo = project.trim();
            } else if (freeFormText.length > 0) {
              newPunch.jobProjectInfo = freeFormText.trim();
            } else {
              newPunch.jobProjectInfo = SET_EMPTY;
            }

            getValidateScenarios(isPass, action, newPunch, {})
              .then((docRef) => {
                resolve(docRef);
              })
              .catch((error) => {
                reject(error);
              });
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        // update old punch
        let status = EDIT_STATUS;
        let newPunch = getPunch(
          activityGroup.value,
          activityName,
          selectedBuilding,
          selectedDistrict,
          customerSiteVal,
          exceptionName,
          isException,
          jobfamily,
          showFreeForm ? freeFormText : project,
          status,
          version,
          selectedWorker.workerId,
          actionTS,
          inTS,
          inLocalTS,
          outTS,
          outLocalTS,
          actionBy,
          DEVICE_DETAILS,
          categoryPunch,
          projectDetails
        );

        if (deleteFlag && deleteFlag === true) {
          const deletedId = activity?.id;
          if (deletedId) {
            deleteIndividualPunch(
              deletedId,
              loggedInSupervisor,
              newPunch.inLocalTS,
              newPunch.outLocalTS,
              inProgressPunchFlag
            )
              .then(async (result) => {
                if (result) {
                  let punch;
                  await punchesRef()
                    .doc(deletedId)
                    .get()
                    .then((data) => {
                      if (data.exists) {
                        if (data.status != "deleted") {
                          punch = { ...data.data(), punchId: data.id };
                        }
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                      reject(error);
                    });

                  let weekNumber = getWeekNumber(newPunch.inLocalTS);
                  if (newPunch.outLocalTS)
                    weekNumber = getWeekNumber(newPunch.outLocalTS);
                  const workerId = newPunch.workerId;
                  const docId = weekNumber + "-" + workerId;
                  newPunch.weekNumber = weekNumber;
                  const punchDoc = { ...newPunch, id: deletedId };
                  let activityWeekChange = false;
                  let oldActivityDetails = { ...punch, id: deletedId };
                  let oldActivityWeekNumber;
                  if (punch) {
                    if (punch.weekNumber) {
                      oldActivityWeekNumber = punch.weekNumber;
                    } else {
                      if (punch.outLocalTS) {
                        oldActivityWeekNumber = getWeekNumber(punch.outLocalTS);
                      } else {
                        oldActivityWeekNumber = getWeekNumber(punch.inLocalTS);
                      }
                    }
                  }
                  if (oldActivityWeekNumber != weekNumber) {
                    activityWeekChange = true;
                  }

                  console.log("delete activityWeekChange:", activityWeekChange);
                  await createorUpdateTimeSheetfromPunch(
                    punchDoc,
                    loggedInSupervisor,
                    true,
                    inProgressPunchFlag,
                    activityWeekChange,
                    oldActivityDetails
                  )
                    .then((resultData) => {
                      if (resultData && Object.keys(resultData).length > 0) {
                        setActivityGroupTotals(
                          resultData?.weekTotalHours?.activityGroupTotals
                        );
                      }
                      resolve(deletedId);
                      setFlag(
                        true,
                        t("pgReview.msgDeleteSuccess"),
                        t("pgPunch.tlConfirmation"),
                        true
                      );
                    })
                    .catch((error) => {
                      console.log("Error while individual delete:", error);
                      reject(error);
                    });
                }
              })
              .catch((error) => {
                console.log("Error while individual delete:", error);
                reject(error);
              });
          }
        } else {
          currentPunch = {
            inLocalTS: inLocalTS,
            id: activity?.id,
            outLocalTS: outLocalTS,
          };

          console.log("on update zz", newPunch);

          const startdate = moment(newPunch.inLocalTS).format(
            dateConfig.format6
          );
          const endDate = moment(newPunch.outLocalTS).format(
            dateConfig.format6
          );

          const recentPunchIn = moment(newPunch.inLocalTS).format(
            dateConfig.format7
          );
          const recentPunchOut = moment(newPunch.outLocalTS).format(
            dateConfig.format7
          );
          let isPass = "";
          let action = "";
          const dayDiff = parseInt(
            moment
              .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
              .asMinutes()
          );
          //  //console.log("DayDIff....update..." + dayDiff,"workerId",newPunch.workerId,);
          //  //console.log("startDate:",moment(startdate).subtract(1, "days").format(dateConfig.format4));
          //  //console.log("endDate:",moment(endDate).add(1, "days").format(dateConfig.format4));
          getNewWorkerPunchRecords(
            newPunch.workerId,
            moment(startdate).subtract(1, "days").format(dateConfig.format4),
            moment(endDate).add(1, "days").format(dateConfig.format4)
          )
            .then(async (querySnapshot) => {
              ////console.log("querySnapshot....." + querySnapshot);
              if (querySnapshot != undefined && querySnapshot.length > 0) {
                querySnapshot.forEach((doc) => {
                  if (doc.outLocalTS !== "") {
                    doc.inLocalTS = moment(doc.inLocalTS).format(
                      dateConfig.format7
                    );
                    doc.outLocalTS = moment(doc.outLocalTS).format(
                      dateConfig.format7
                    );
                    currentPunch.inLocalTS = moment(
                      currentPunch.inLocalTS
                    ).format(dateConfig.format7);
                    currentPunch.outLocalTS = moment(
                      currentPunch.outLocalTS
                    ).format(dateConfig.format7);

                    if (recentPunchOut == recentPunchIn) {
                      isPass = ZERO;
                    } else if (recentPunchOut < recentPunchIn) {
                      isPass = NEGATIVE;
                    }
                    // else if (dayDiff >= 1440) {
                    //   isPass = DAY24HRS;
                    // }
                    else if (
                      currentPunch.id !== doc.id &&
                      recentPunchIn == doc.inLocalTS &&
                      recentPunchOut == doc.outLocalTS
                    ) {
                      isPass = EQUAL;
                    } else if (
                      currentPunch.inLocalTS != doc.inLocalTS &&
                      currentPunch.outLocalTS != doc.outLocalTS
                    ) {
                      if (
                        currentPunch.id != doc.id &&
                        ((doc.inLocalTS > recentPunchIn &&
                          doc.inLocalTS < recentPunchOut) ||
                          (doc.outLocalTS > recentPunchIn &&
                            doc.outLocalTS < recentPunchOut) ||
                          (recentPunchIn > doc.inLocalTS &&
                            recentPunchIn < doc.outLocalTS) ||
                          (recentPunchOut > doc.inLocalTS &&
                            recentPunchOut < doc.outLocalTS))
                      ) {
                        isPass = OVERLAPPING;
                      }
                    } else {
                      if (
                        isPass != NEGATIVE &&
                        isPass != ZERO &&
                        // isPass != DAY24HRS &&
                        isPass != EQUAL &&
                        isPass != OVERLAPPING
                      ) {
                        isPass = POSITIVE;
                        action = UPDATE;
                      }
                    }
                  } else {
                    doc.inLocalTS = moment(doc.inLocalTS).format(
                      dateConfig.format7
                    );
                    if (recentPunchOut == recentPunchIn) {
                      isPass = ZERO;
                    } else if (
                      currentPunch.id != doc.id &&
                      recentPunchIn < doc.inLocalTS &&
                      recentPunchOut > doc.inLocalTS
                    ) {
                      isPass = OVERLAPPING;
                    } else if (recentPunchOut < recentPunchIn) {
                      isPass = NEGATIVE;
                    }
                    // else if (dayDiff >= 1440) {
                    //   isPass = DAY24HRS;
                    // }
                    else {
                      if (isPass != OVERLAPPING && isPass != EQUAL) {
                        isPass = POSITIVE;
                        action = UPDATE;
                      }
                    }
                  }
                });
              } else {
                if (recentPunchOut == recentPunchIn) {
                  isPass = ZERO;
                } else if (recentPunchOut < recentPunchIn) {
                  isPass = NEGATIVE;
                }
                // else if (dayDiff >= 1440) {
                //   isPass = DAY24HRS;
                // }
                else {
                  if (
                    isPass != ZERO &&
                    // isPass != DAY24HRS &&
                    isPass != NEGATIVE
                  ) {
                    isPass = POSITIVE;
                    action = UPDATE;
                  }
                }
              }
              if (project && !showFreeForm) {
                newPunch.jobProjectInfo = project.trim();
              } else if (freeFormText.length > 0) {
                newPunch.jobProjectInfo = freeFormText.trim();
              } else {
                newPunch.jobProjectInfo = SET_EMPTY;
              }
              console.log("isPass:", isPass);
              getValidateScenarios(isPass, action, newPunch, currentPunch)
                .then((docRef) => {
                  resolve(docRef);
                })
                .catch((error) => {
                  ////console.log(error);
                  reject(error);
                });
            })
            .catch((error) => {
              ////console.log(error);
              reject(error);
            });
        }
      }
    });
  };
  const setFlag = (msg, txt, titletxt, navigate) => {
    setConfirmationMsg(msg);
    setConfirmationMsgText(txt);
    setConfirmationTitleText(titletxt);
    setAllowNavigation(navigate);
  };

  const getValidateScenarios = (isPass, action, newPunch, currentPunch) => {
    return new Promise(async (resolve, reject) => {
      //console.log("getValidationScenarios called ..........",isPass);
      switch (isPass) {
        case NEGATIVE:
          setErrorData(true);
          reject(NEGATIVE);
          // setAddopen(false);
          // onCancel(true);
          break;
        case ZERO:
          setErrorData(true);
          // setAddopen(false);
          // onCancel(true);
          reject(ZERO);
          break;
        case EQUAL:
          setErrorData(true);
          // setAddopen(false);
          // onCancel(true);
          reject(EQUAL);
          break;
        // case DAY24HRS:
        //   setFlag(
        //     true,
        //     t("pgReview.dialogueMsgs.errMsgDay24Hrs"),
        //     "Error",
        //     false
        //   );
        //   break;
        case OVERLAPPING:
          setErrorData(true);
          // setAddopen(false);
          // onCancel(true);
          reject(OVERLAPPING);
          break;
        case POSITIVE:
          ////console.log("POsitive" + isPass);
          if (action == ADD) {
            if (project && !showFreeForm) {
              newPunch.jobProjectInfo = project.trim();
            } else if (freeFormText.length > 0) {
              newPunch.jobProjectInfo = freeFormText.trim();
            } else {
              newPunch.jobProjectInfo = SET_EMPTY;
            }
            //console.log("add punch:",newPunch);
            addPunch(newPunch, true, isPersist)
              .then((result) => {
                const weekNumber = getWeekNumber(newPunch.outLocalTS);
                const workerId = newPunch.workerId;
                const docId = weekNumber + "-" + workerId;
                const punchDoc = { ...newPunch, id: result };
                createorUpdateTimeSheetfromPunch(
                  punchDoc,
                  loggedInSupervisor
                ).then((resultData) => {
                  // console.log('resultData:', resultData);
                  if (resultData && Object.keys(resultData).length > 0) {
                    setActivityGroupTotals(
                      resultData?.weekTotalHours?.activityGroupTotals
                    );
                  }
                  setcreatedPunchId(result);

                  setFlag(
                    true,
                    t("pgReview.dialogueMsgs.msgSuccess"),
                    t("pgPunch.tlConfirmation"),
                    true
                  );
                  setErrorData(false);
                  resolve(result);
                });
                //console.log("new punchDetails:",result.id);
              })

              .catch((error) => {
                ////console.log(error);
                reject(error);
              });
          } else {
            if (project && !showFreeForm) {
              newPunch.jobProjectInfo = project.trim();
            } else if (freeFormText.length > 0) {
              newPunch.jobProjectInfo = freeFormText.trim();
            } else {
              newPunch.jobProjectInfo = SET_EMPTY;
            }
            if (lastPunchId && lastPunchId === currentPunch.id)
              isPersist = getActivityDetails(
                activityGroupOption,
                activityGroup
              );
            //console.log("updating punchDetails:",newPunch);
            //console.log("updating punchDetails id:",currentPunch.id);
            let punch;
            await punchesRef()
              .doc(currentPunch.id)
              .get()
              .then((data) => {
                if (data.exists) {
                  if (data.status != "deleted") {
                    punch = { ...data.data(), punchId: data.id };
                    console.log("punch:", punch);
                  }
                }
              })
              .catch((error) => {
                console.log(error);
                reject(error);
              });
            updatePunch(currentPunch.id, newPunch, false, isPersist)
              .then((result) => {
                //console.log("result ",result);
                let weekNumber = getWeekNumber(newPunch.outLocalTS);
                const workerId = newPunch.workerId;
                const docId = weekNumber + "-" + workerId;
                newPunch.weekNumber = weekNumber;
                const punchDoc = { ...newPunch, id: currentPunch.id };
                let activityWeekChange = false;
                let oldActivityDetails = { ...punch, id: currentPunch.id };
                let oldActivityWeekNumber;
                if (punch) {
                  if (punch.weekNumber) {
                    oldActivityWeekNumber = punch.weekNumber;
                  } else {
                    if (punch.outLocalTS) {
                      oldActivityWeekNumber = getWeekNumber(punch.outLocalTS);
                    } else {
                      oldActivityWeekNumber = getWeekNumber(punch.inLocalTS);
                    }
                  }
                }
                if (oldActivityWeekNumber != weekNumber) {
                  activityWeekChange = true;
                }

                console.log("activityWeekChange:", activityWeekChange);
                createorUpdateTimeSheetfromPunch(
                  punchDoc,
                  loggedInSupervisor,
                  false,
                  false,
                  activityWeekChange,
                  oldActivityDetails
                )
                  .then((resultData) => {
                    // console.log('resultData::', resultData);
                    if (resultData && Object.keys(resultData).length > 0) {
                      setActivityGroupTotals(
                        resultData?.weekTotalHours?.activityGroupTotals
                      );
                    }
                    setErrorData(false);
                    resolve(currentPunch.id);
                    setFlag(
                      true,
                      t("pgReview.dialogueMsgs.msgSuccess"),
                      t("pgPunch.tlConfirmation"),
                      true
                    );
                  })
                  .catch((error) => {
                    ////console.log(error);
                    reject(error);
                  });
              })
              .catch((error) => {
                ////console.log(error);
                reject(error);
              });
          }
          break;
        default:
          ////console.log("default" + isPass);
          if (action == ADD) {
            if (project && !showFreeForm) {
              newPunch.jobProjectInfo = project.trim();
            } else if (freeFormText.length > 0) {
              newPunch.jobProjectInfo = freeFormText.trim();
            } else {
              newPunch.jobProjectInfo = SET_EMPTY;
            }
            addPunch(newPunch, true, isPersist)
              .then((result) => {
                const weekNumber = getWeekNumber(newPunch.outLocalTS);
                const workerId = newPunch.workerId;
                const docId = weekNumber + "-" + workerId;
                const punchDoc = { ...newPunch, id: result };
                createorUpdateTimeSheetfromPunch(
                  punchDoc,
                  loggedInSupervisor
                ).then((resultData) => {
                  setcreatedPunchId(result);
                  if (resultData && Object.keys(resultData).length > 0) {
                    setActivityGroupTotals(
                      resultData?.weekTotalHours?.activityGroupTotals
                    );
                  }
                  setFlag(
                    true,
                    t("pgReview.dialogueMsgs.msgSuccess"),
                    t("pgPunch.tlConfirmation"),
                    true
                  );
                  setErrorData(false);
                  resolve(result);
                });
                //console.log("new punchDetails:",result.id);
              })
              .catch((error) => {
                ////console.log(error);
                reject(error);
              });
          } else {
            if (project && !showFreeForm) {
              newPunch.jobProjectInfo = project.trim();
            } else if (freeFormText.length > 0) {
              newPunch.jobProjectInfo = freeFormText.trim();
            } else {
              newPunch.jobProjectInfo = SET_EMPTY;
            }
            if (lastPunchId && lastPunchId === currentPunch.id)
              isPersist = getActivityDetails(
                activityGroupOption,
                activityGroup
              );

            let punch;
            await punchesRef()
              .doc(currentPunch.id)
              .get()
              .then((data) => {
                if (data.exists) {
                  if (data.status != "deleted") {
                    punch = { ...data.data(), punchId: data.id };
                    console.log("punch:", punch);
                  }
                }
              })
              .catch((error) => {
                console.log(error);
                reject(error);
              });

            updatePunch(currentPunch.id, newPunch, false, isPersist)
              .then((result) => {
                ////console.log(result);
                let weekNumber = getWeekNumber(newPunch.outLocalTS);
                const workerId = newPunch.workerId;
                const docId = weekNumber + "-" + workerId;
                newPunch.weekNumber = weekNumber;
                const punchDoc = { ...newPunch, id: currentPunch.id };
                let activityWeekChange = false;
                let oldActivityDetails = { ...punch, id: currentPunch.id };
                let oldActivityWeekNumber;
                if (punch) {
                  if (punch.weekNumber) {
                    oldActivityWeekNumber = punch.weekNumber;
                  } else {
                    if (punch.outLocalTS) {
                      oldActivityWeekNumber = getWeekNumber(punch.outLocalTS);
                    } else {
                      oldActivityWeekNumber = getWeekNumber(punch.inLocalTS);
                    }
                  }
                }
                if (oldActivityWeekNumber != weekNumber) {
                  activityWeekChange = true;
                }

                console.log("activityWeekChange:", activityWeekChange);
                createorUpdateTimeSheetfromPunch(
                  punchDoc,
                  loggedInSupervisor,
                  false,
                  false,
                  activityWeekChange,
                  oldActivityDetails
                )
                  .then((resultData) => {
                    if (resultData && Object.keys(resultData).length > 0) {
                      setActivityGroupTotals(
                        resultData?.weekTotalHours?.activityGroupTotals
                      );
                    }
                    setErrorData(false);
                    resolve(currentPunch.id);
                    setFlag(
                      true,
                      t("pgReview.dialogueMsgs.msgSuccess"),
                      t("pgPunch.tlConfirmation"),
                      true
                    );
                  })
                  .catch((error) => {
                    ////console.log(error);
                    reject(error);
                  });
              })
              .catch((error) => {
                ////console.log(error);
                reject(error);
              });
          }
          break;
      }
    });
  };

  const handleClose = async (docRef) => {
    //console.log("save function called:",docRef);
    if (onAddClose) {
      const inTS = getDateAndTime(
        new Date(selectStartDate),
        new Date(startDate)
      );
      const outTS = getDateAndTime(new Date(selectEndDate), new Date(endDate));
      onAddClose({
        start: inTS,
        end: outTS,
        group: activityGroup,
        districtId: selectedDistrict,
        buildingId: selectedBuilding,
        jobfamily: jobfamily,
        project: project,
        freeFormText: freeFormText,
        exceptionName: exception,
        jobProjectInfo: project,
        id: docRef,
        customerSite: customerSite,
        weekNumber: getWeekNumber(outTS),
        projectDetails: projectDetails,
      });
      setSelectedDistrict("");
      setJobfamily("");
      setProject("");
      setFreeFormText("");
      // setStartDate("");
      // setEndDate("");
    }
  };

  const updateEvent = async () => {
    //console.log("updateEvent called");
    const inTS = getDateAndTime(new Date(selectStartDate), new Date(startDate));
    const outTS = getDateAndTime(new Date(selectEndDate), new Date(endDate));
    if (onUpdateClose) {
      onUpdateClose({
        start: inTS,
        end: outTS,
        group: activityGroup,
        districtId: selectedDistrict,
        buildingId: selectedBuilding,
        Id: activity?.id,
        jobfamily: jobfamily,
        project: project,
        exceptionName: exception,
        jobProjectInfo: project,
        freeFormText: freeFormText,
        customerSite: customerSite,
        weekNumber: getWeekNumber(outTS),
        projectDetails: projectDetails,
      });
      setSelectedDistrict("");
      setJobfamily("");
      setProject("");
      setFreeFormText();
      // setStartDate("");
      // setEndDate("");
    }
  };

  const cancelModal = () => {
    onCancel && onCancel(true);
    setSelectedDistrict("");
    setSelectedBuilding("");
    setJobfamily("");
    setProject("");
    setFreeFormText("");
    setActivityGroup("");
    setException("");
    // setStartDate("");
    // setEndDate("");
  };

  const handleSplit = () => {
    console.log("handle split");
    dataForSplitAndSplitOpen(activity);
  };

  const deleteModal = () => {
    setConfirmDialog({ ...confirmDialog, isOpen: false });

    onDelete && onDelete(activity?.id);
    setSelectedDistrict("");
    setSelectedBuilding("");
    setJobfamily("");
    setProject("");
    setFreeFormText("");
    setActivityGroup("");
    setException("");
  };

  React.useEffect(() => {
    if (selectedWorker && selectedWorker.countryCode) {
      setLoading(true);
      if (selectedWorker.country === "testCountry") {
        selectedWorker.countryCode = "testCountry";
      }
      dispatch(
        getLocations(
          selectedWorker.countryCode,
          selectedWorker.alternateCountryCode
        )
      );

      getLocationForCountry(
        selectedWorker.countryCode,
        selectedWorker.alternateCountryCode
      )
        .then((data) => {
          setLoading(false);
          setDistricts([...data]);
        })
        .catch(() => {
          setLoading(false);
          ////console.log("BulkEntry: Err loading locations data");
        });

      getProjectsByCountry(selectedWorker.country)
        .then((data) => {
          if (data) {
            setLoading(false);
            dispatch(getProjectDetailsByCountry(data));
          }
        })
        .catch((err) => {
          console.error("No response from getProjectDetailsByCountry:: ", err);
        });
    } else {
      setDistricts([]);
    }
  }, [selectedWorker]);

  const handleTextFieldChange = (event) => {
    const textValue = event.target.value;
    if (textValue) setFreeFormText(textValue);
    else setFreeFormText("");
    if (textValue.length == 0) setFreeFormText("");
    setProject("");
  };

  const exceptionChange = (event) => {
    setException(event.target.value);
  };

  React.useEffect(() => {
    let gValid = activityGroup ? true : false;
    let fValid =
      activityGroup && activityGroup.value === "Leave"
        ? true
        : jobfamily
          ? true
          : false;
    setDisabled(!fValid || !gValid);

    const keys = Object.keys(activityGroupOption);
    //console.log("keys",keys);
    ////console.log("changed activity groupccase",activityGroup?.value?.toLowerCase());
    for (let eachKey in activityGroupOption) {
      ////console.log("eachKey:",Math.floor(eachKey));
      if (
        activityGroupOption[eachKey].value?.toLowerCase() ===
        activityGroup?.value?.toLowerCase()
      ) {
        console.log("filtered activity", Math.floor(eachKey));
        setSelectedIndexGroup(Math.floor(eachKey));
      }
    }
  }, [activityGroup, jobfamily, setDisabled, lastpunchDetails, addOpen]);

  const getWeekError = (errors, field) => {
    if (!errors) return false;
    if (!errors[field]) return false;
    return errors[field];
  };

  const customerSiteChange = (event) => {
    const value = event.target.value;
    setCustomerSite(value);
    if (value.length === 0) {
      setErrCustomerSite(true);
      setCustomerSite("");
    } else {
      setErrCustomerSite(false);
    }
  };

  const projectDetailsChange = (event) => {
    const value = event.target.value;

    setProjectDetails(value);
  };

  let saveLabel = properCase(t("pgPunch.brnSave"));

  if (activity?.updateFlag && activity?.updateFlag === true)
    saveLabel = properCase(t("other.tlUpdate"));

  React.useEffect(() => {
    if (!type || type == "add") {
      setException(DEFAULT_EXCEPTION);
    }
    if (activity?.exceptionName) {
      setException(
        activity?.exceptionName && activity.exceptionName.length > 0
          ? activity.exceptionName
          : DEFAULT_EXCEPTION
      );
    }
  }, [type, activity]);

  const reversedActivityGroups = [...activityGroupOption].reverse();
  const closeModalConfirmationInTripMsg= () => {
    setConfirmationInTrip(false);
   
  };
  return (
    <>
      <Dialog
        PaperComponent={PaperComponent}
        hideBackdrop
        // fullScreen={fullScreen}
        open={addOpen}
        onClose={(event, reason) => {
          ////// console.log(reason);
          if (reason == "escapeKeyDown" || reason == "backdropClick") {
            cancelModal();
          }
        }}
        aria-labelledby="responsive-dialog-title"
      >
        <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            id="drag-handle"
            style={{
              cursor: "move",
              gap: 16,
              height: "36px",
              // backgroundColor: "#f1f3f4",
              paddingLeft: 24,
              paddingRight: 16,
              paddingTop: 8,
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              style={{ gap: 16 }}
            >
              <Typography>{activity?.title}</Typography>
            </Box>
            <IconButton size="small" onClick={cancelModal}>
              <Close fontSize="inherit" />
            </IconButton>
          </Box>
          <Box
            className="content"
            display="flex"
            flexDirection="column"
            style={{ gap: 16 }}
            px={3}
          >
            <GroupTabs
              tabs={reversedActivityGroups}
              initialSelect={
                activity?.updateFlag
                  ? selectedIndexGroup
                  : lastpunchDetails?.activityGroup
                    ? reversedActivityGroups?.length - lastPunchIndex - 1
                    : 0
              }
              activityGroup={lastpunchDetails}
              onChange={(tab) => {
                setActivityGroup(tab);
                setProject("");
                setFreeFormText("");
                if (tab.value.toLowerCase() == "leave") {
                  const defaultJobRole = selectedWorker.jobRole ? selectedWorker.jobRole : "";
                  setJobfamily(defaultJobRole);
                } else if (
                  jobfamily.toLowerCase() == "leave" &&
                  tab.value.toLowerCase() != "leave"
                ) {
                  setJobfamily("");
                }
              }}
              isupdateFlag={
                activity?.updateFlag && activity?.updateFlag === true
              }
              setactivity={(update) => {
                setActivityGroup(update);
                console.log("this is z activitygroup ", activityGroup);
              }}
              selectedActivityGroup={activityGroup}
            />
            <Grid container spacing={2}>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <KeyboardDatePicker
                  disableBackdropClick
                  placeholder="dd/MM/yyyy"
                  margin="none"
                  id="date-picker-dialog"
                  format="dd/MM/yyyy"
                  value={selectStartDate}
                  onChange={(newValue) => {
                    setSelectStartDate(newValue);
                  }}
                  minDate={selectedWeekStartDate}
                  maxDate={
                    //new Date(moment(selectedWeekStartDate).endOf("week"))
                    moment(new Date()).add(1, "years").endOf("week")
                  }
                  inputVariant="outlined"
                  size="small"
                  label={properCase(t("pgReview.tableHeads.startDate"))}
                  keyboardIcon={<DateRange fontSize="inherit" />}
                  error={selectStartErr}
                  helperText={props.endDateErrMsg}
                  disabled={isTimesheetEditRestricted}
                />
              </Grid>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <KeyboardDatePicker
                  disableBackdropClick
                  placeholder="dd/MM/yyyy"
                  margin="none"
                  id="date-picker-dialog"
                  format="dd/MM/yyyy"
                  value={selectEndDate}
                  onChange={(newValue) => {
                    setSelectEndDate(newValue);
                  }}
                  minDate={selectedWeekStartDate}
                  maxDate={
                    //new Date(moment(selectedWeekStartDate).endOf("week"))
                    moment(new Date()).add(1, "years").endOf("week")
                  }
                  inputVariant="outlined"
                  size="small"
                  label={properCase(t("pgReview.tableHeads.endDate"))}
                  keyboardIcon={<DateRange fontSize="" />}
                  error={selectEndErr}
                  helperText={props.endDateErrMsg}
                  disabled={isTimesheetEditRestricted}
                />
              </Grid>
              {activity?.updateFlag == true && (
                <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                  <Button
                    color="primary"
                    onClick={handleSplit}
                    disabled={
                      flagForChanges || flagForEventDropOrDrag || isSaveDisabled || isTimesheetEditRestricted
                    }
                  >
                    {properCase(t("other.tlsplit"))}
                  </Button>
                </Grid>
              )}
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <KeyboardTimePicker
                  ampm={false}
                  disableBackdropClick
                  placeholder="hh:mm"
                  margin="none"
                  id="date-picker-dialog"
                  // format="hh:mm a"
                  value={startDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                  }}
                  inputVariant="outlined"
                  size="small"
                  label={properCase(t("pgReview.tableHeads.startTime"))}
                  keyboardIcon={<Watch fontSize="inherit" />}
                  error={props.endDateErr}
                  helperText={props.endDateErrMsg}
                  disabled={isTimesheetEditRestricted}
                />
              </Grid>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <KeyboardTimePicker
                  ampm={false}
                  disableBackdropClick
                  placeholder="dd/MM/yyyy"
                  margin="none"
                  id="date-picker-dialog"
                  // format="hh:mm a"
                  value={endDate}
                  onChange={(newValue) => {
                    setEndDate(newValue);
                  }}
                  inputVariant="outlined"
                  size="small"
                  label={properCase(t("pgReview.tableHeads.endTime"))}
                  keyboardIcon={<Watch fontSize="" />}
                  error={props.endDateErr}
                  helperText={props.endDateErrMsg}
                  disabled={isTimesheetEditRestricted}
                />
              </Grid>
              {/* {activity?.updateFlag == true && (
                <Grid>
                  <Button variant="contained" onClick={handleSplit}>
                    Split
                  </Button>
                </Grid>
              )} */}
            </Grid>

            <Grid container spacing={2}>
              <Grid item md={4} sm={12} xs={12} lg={4} xl={4}>
                <Autocomplete
                  disabled={loading || !selectedWorker || isTimesheetEditRestricted}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  fullWidth
                  //disableClearable

                  value={{ district: selectedDistrict }}
                  defaultValue={{ district: props.value }}
                  options={districts}
                  getOptionLabel={(option) => option.district}
                  renderInput={(params) => (
                    <TextField
                      // label={t("other.timeSheetDIstrictDropdown")}
                      label={districtLabel}
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                      }}
                      size="small"
                      // placeholder={t("other.timeSheetDIstrictDropdown")}
                      placeholder={districtLabel}
                      error={getWeekError(errors, "districtId")}
                      variant="outlined"
                    />
                  )}
                  onInputChange={(event, newValue) => {
                    if (!newValue) {
                      //setDistricts([]);
                      setSelectedDistrict("");
                      setSelectedBuilding("");
                      setBuildings([]);
                    }
                  }}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      const tempbuild = newValue.buildings;
                      let activatedBuilding = Object.keys(tempbuild).filter(
                        (e) => tempbuild[e].activityEnabled === true
                      );

                      if (newValue && newValue.buildings) {
                        setSelectedDistrict(newValue.district);
                        setSelectedBuilding("");
                        selectedWorker.isApprover
                          ? setBuildings([
                            ...activatedBuilding,
                            "Customer Site",
                            "Remote",
                          ])
                          : setBuildings([
                            ...activatedBuilding,
                            "Customer Site",
                          ]);
                      }
                    }
                  }}
                />
              </Grid>

              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <Autocomplete
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  fullWidth
                  //disableClearable
                  value={selectedBuilding}
                  defaultValue={{ value: props.value }}
                  options={buildings}
                  loading={buildings.length == 0}
                  disabled={loading || !selectedWorker || !selectedDistrict || isTimesheetEditRestricted}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      //label={t("pgPunch.lblBuilding")}
                      label={buildingLabel}
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                      }}
                      placeholder={buildingLabel}
                      error={getWeekError(errors, "buildingId")}
                      variant="outlined"
                      size="small"
                    />
                  )}
                  onInputChange={(event, newValue) => {
                    if (!newValue) {
                      // setBuildings([]);
                      setSelectedBuilding("");
                    }
                  }}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setSelectedBuilding(newValue);
                    }
                  }}
                />
              </Grid>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                {customerSiteVisible && (
                  <FormControl fullWidth>
                    <TextField
                      label={customerSiteLabel}
                      InputLabelProps={{
                        shrink:
                          customerSite || flagForCustomerSiteVisible
                            ? true
                            : false,
                      }}
                      // inputRef={(ref) => {
                      //   if (ref) {
                      //     console.log("this is zzz ref ", ref);
                      //   }
                      // }}
                      onFocus={(event) => {
                        setFlagForCustomerSiteVisible(true);
                      }}
                      onBlur={(event) => {
                        setFlagForCustomerSiteVisible(false);
                      }}
                      //placeholder={customerSiteLabel}
                      //value={activity?.customerSite ? activity?.customerSite : customerSite}
                      //value={customerSite}
                      // autoFocus={true}
                      value={customerSite}
                      fullWidth
                      size="small"
                      variant="outlined"
                      name="customerSite"
                      onChange={customerSiteChange}
                      error={errCustomerSite}
                      disabled={isTimesheetEditRestricted}
                    // onChange={() => trigger()}
                    />
                  </FormControl>
                )}
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <Autocomplete
                  className="content"
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  fullWidth
                  value={{ label: jobfamily }}
                  options={jobFamiliyOption}
                  getOptionLabel={(option) =>
                    option.label === "Leave"
                      ? selectedWorker.jobRole && selectedWorker.jobRole
                      : option.label
                  }
                  //  disabled={
                  //  disabled || activityGroup?.value === "Leave" ? true : false                                          
                  //  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        style: { fontSize: 14 },
                      }}
                      size="small"
                      variant="outlined"
                      label={timesheetJobFamily}
                    // error={getErrors(errors.records, index, "family")}
                    />
                  )}
                  onInputChange={(event, newValue) => {
                    if (!newValue) {
                      setJobfamily("");
                      setProjectOptions([]);
                      setProject("");
                    }
                  }}
                  onChange={(_, data) => {
                    if (data) {
                      setJobfamily(data.value);
                      setProjectInfoEntryType(data.projectInfoEntryType);
                    }
                  }}
                  disabled={isTimesheetEditRestricted}
                />
              </Grid>
              {projectInfoEntryType === "id" && (
                <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                  <FormControl fullWidth>
                    <TextField
                      label={t("other.lblProjectDetails")}
                      // InputLabelProps={}

                      // onFocus={(event) => {

                      // }}
                      // onBlur={(event) => {

                      // }}
                      // autoFocus={true}
                      value={projectDetails}
                      fullWidth
                      size="small"
                      variant="outlined"
                      name="projectDetails"
                      onChange={projectDetailsChange}
                      disabled={isTimesheetEditRestricted}
                    />
                  </FormControl>
                </Grid>
              )}
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                {showFreeForm ? (
                  <FormControl className="content" fullWidth>
                    <TextField
                      // disabled={
                      //   disabled === true || activityGroup.value === "Meal" ? true : false
                      // }
                      label={activityGroup?.value === 'Project'
                        ? properCase(t("other.timeSheetDetails")) + '*'
                        : properCase(t("other.timeSheetDetails"))}
                      fullWidth
                      //defaultValue={lastpunchDetails?.jobProjectInfo}
                      value={freeFormText}
                      size="small"
                      variant="outlined"
                      onChange={handleTextFieldChange}
                      onInputChange={handleTextFieldChange}
                      {...props}
                      disabled={
                        disabled ||
                          activityGroup?.value?.toLowerCase() === "meal"
                          ? true
                          : false
                          || isTimesheetEditRestricted
                      }
                    />
                  </FormControl>
                ) : (
                  <Autocomplete
                    disabled={
                      disabled || activityGroup?.value?.toLowerCase() === "meal"
                        ? true
                        : false
                        || isTimesheetEditRestricted
                    }
                    className="content"
                    selectOnFocus
                    //inputValue={project}
                    value={{ name: project }}
                    clearOnBlur
                    handleHomeEndKeys
                    fullWidth
                    options={projectOption}
                    getOptionLabel={(option) => {
                      // console.log("This is option ", option.name);
                      // console.log("This is project options ", projectOption);
                      return option.name;
                    }}
                    groupBy={(option)=> option.parent}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          style: { fontSize: 14 },
                        }}
                        size="small"
                        variant="outlined"
                        label={
                          activityGroup?.value === "Leave"
                            ? properCase(t("other.timesheetLeaveType"))
                            : activityGroup?.value === 'Project'
                              ? properCase(t("other.timeSheetDetails")) + '*'
                              : properCase(t("other.timeSheetDetails"))
                        }
                      // error={getErrors(errors.records, index, "details")}
                      />
                    )}
                    onChange={(_, data) => {
                      if (data) {
                        setProject(data.name);
                      }
                      // error={getErrors(errors.records, index, "details")}
                    }}
                    onInputChange={(event, newValue) => {
                      if (!newValue) {
                        setProject("");
                        setFreeFormText("");
                        //setActivityGroupOption([]);
                      }
                    }}
                  />
                )}
              </Grid>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <FormControl size="small" variant="outlined" fullWidth>
                  <InputLabel id="exception-sel">
                    {properCase(t("pgReview.tableStaticText.exception"))}
                  </InputLabel>
                  <Select
                    fullWidth
                    labelId="exception-sel"
                    label={"Exception"}
                    id="exception-select"
                    value={exception?.toLowerCase()}
                    //defaultValue={{ exception: (activity?.exceptionName && activity.exceptionName.length > 0 ? activity.exceptionName : "No Exception") }}
                    onChange={exceptionChange}
                    disabled={isTimesheetEditRestricted}
                  >
                    {exceptionOptions.map((item, idx) => (
                      <MenuItem key={idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box
            style={{ gap: 16 }}
            px={2}
            py={1}
            display="flex"
            flexDirection="row"
          >
            {activity?.updateFlag && activity?.updateFlag == true && (
              <Button
                disableElevation
                size="medium"
                justifyContent="left"
                disabled={
                  isDeleteDisabled || isTimesheetEditRestricted
                  //!inProgressPunchFlag && (flagForChanges || flagForEventDropOrDrag)
                }
                onClick={() => {
                  setConfirmDialog({
                    ...confirmDialog,
                    isOpen: true,
                    onConfirm: () => {
                      setConfirmDialog((p) => ({ ...p, isLoading: true,isOpen:false }));
                      saveActivity(true, (success) => {
                        setConfirmDialog((p) => ({ ...p, isLoading: false }));
                        setDeleteButtonEnabled(true);
                      });
                    },
                  });
                }}
                style={{
                  // backgroundColor:inProgressPunchFlag || !(flagForChanges || flagForEventDropOrDrag )?theme.palette.error.main:"",
                  // color:inProgressPunchFlag || !(flagForChanges || flagForEventDropOrDrag )?"#fff":"",
                  backgroundColor: !isDeleteDisabled && !isTimesheetEditRestricted
                    ? theme.palette.error.main
                    : "",
                  color: !isDeleteDisabled && !isTimesheetEditRestricted ? "#fff" : "",
                }}
              >
                {deleteLabel}
              </Button>
            )}
            <Box flexGrow={1} />

            <Button
              disableElevation
              size="medium"
              disabled={isCancelDisabled}
              onClick={cancelModal}
              sx={{ color: (t) => t.palette.text.secondary }}
            >
              {properCase(t("pgPunch.btnCancel"))}
            </Button>
            {console.log(
              "SAVE DISABLED ",
              isSaveDisabled,
              flagForChanges,
              flagForEventDropOrDrag,
              isTimesheetEditRestricted,
              isTimesheetEditRestricted  ? isTimesheetEditRestricted:   (isSaveDisabled || (!flagForChanges && !flagForEventDropOrDrag))
            )}
            <Button
              variant="contained"
              color="primary"
              disabled={
                isTimesheetEditRestricted  ? isTimesheetEditRestricted:   (isSaveDisabled || (!flagForChanges && !flagForEventDropOrDrag))
              }
              onClick={saveActivity}
              disableRipple
              disableElevation
              size="medium"
            >
              {saveLabel}
            </Button>
          </Box>
        </Box>
      </Dialog>
      <Dialog
            open={confirmationInTrip}
            onClose={closeModalConfirmationInTripMsg}
            disableBackdropClick
          >
            <DialogTitle id="form-dialog-title">Confirmation</DialogTitle>
            <DialogContent>
              <DialogContentText>
                { t("other.lblConfirmationInTripMsgText")} 
                {/* Trip in progress. Complete the trip  */}
                <Link
                  title={t("pgReview.tableStaticText.btnEdit")}
                  style={{ textDecoration: "none", cursor:"pointer", color:"#1B75BC"}}
                 // color="primary"
                  to={{
                    pathname:
                      "/review/transport-details",
                      state: {
                        punch: activity,
                       // selectedWorker: data[dataIndex]["worker"],
                        //isReport: true,
                      },
                   
                  }}
                  onClick={() => {
                    console.log("in link hello", activity?.start);

                    var weekStart = moment(activity?.start).format();
                    console.log(
                      " in Link WEEK SELECTION: weekStart: ",
                      weekStart
                    );

                    dispatch(selectedWeekOnReview({ week: weekStart })); 
                  }}
                >  { " "+t("other.lblClickHere")} </Link> { " "+t("other.lblConfirmationInTripMsgText1")} 
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeModalConfirmationInTripMsg} color="primary">
                {t("pgAddWorker.btnOk")}
              </Button>
            </DialogActions>
          </Dialog>
      <Confirmation
        confirmationMsg={confirmationMsg}
        closeModalConfirmationMsg={closeModalConfirmationMsg}
        confirmationMsgText={confirmationMsgText}
        confirmationTitleText={confirmationTitleText}
        isokayDisabled={isokayDisabled}
        setIsokayDisabled={setIsokayDisabled}
      />

      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
      <Confirmation
        confirmationMsg={confirmationBox.isOpen}
        closeModalConfirmationMsg={deleteDone}
        confirmationMsgText={confirmationBox.subTitle}
        confirmationTitleText={confirmationBox.title}
        isokayDisabled={isokayDisabled}
        setIsokayDisabled={setIsokayDisabled}
      />
    </>
  );
}
